import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { registerMicroApps, start } from 'qiankun';
import './style.css';
import router from './router';
import { useUserStore } from './store/user';
import { useMenuStore } from './store/menu';
// import { subAppConfigs } from './config/subapp';
import { removeToken } from './service/TokenManage';

const app = createApp(App);
const pinia = createPinia();
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
app.use(router);
app.use(pinia);
app.use(ElementPlus);

// 初始化用户状态
const userStore = useUserStore();
userStore.initializeAuth();

// 等待路由解析完成并确保页面已渲染，再启动 qiankun
router.isReady().then(async () => {
  app.mount('#app');
  start();
});

// 调试 Vue Router 路由变化
router.afterEach(to => {
  console.log('--- 主应用路由变化 ---');
  console.log('目标路径 (to.path):', to.path);
  console.log('当前浏览器 URL:', window.location.pathname);
});

// 创建全局 actions，用于子应用访问主应用状态
const createGlobalActions = () => {
  const userStore = useUserStore();
  const menuStore = useMenuStore();

  return {
    ...userStore.createGlobalActions(),
    // 添加全局退出登录方法
    handleLogout: () => {
      console.log('=== 开始执行退出登录流程 ===');
      const userStore = useUserStore();
      const menuStore = useMenuStore();
      // 清理用户状态和菜单状态
      userStore.clearAuth();
      menuStore.clearMenus();
      // 移除token
      removeToken();
      console.log('✅ 已清理所有用户数据和菜单数据');

      // 导航到主应用的登录页
      window.location.href = '/login';

      console.log('✅ 已退出登录并导航到登录页');
    },
    // 获取菜单子项，支持异步加载
    getMenuChildren: async (menuName: string) => {
      // 如果菜单数据为空且不在加载中，尝试重新加载
      if (!menuStore.hasMenuData && !menuStore.isLoading) {
        try {
          const params = { type: 5, parentId: -1 };
          await menuStore.getMenuList(params);
        } catch (error) {
          console.error('重新加载菜单数据失败:', error);
        }
      }

      // 确保使用的是同一个 store 实例
      const store = useMenuStore();
      console.log('main.ts createGlobalActions - 重新获取的store状态:', {
        menuList: store.menuList,
        menuListLength: store.menuCount
      });

      const result = store.getMenuChildren(menuName);
      console.log('main.ts createGlobalActions - 返回结果:', result);
      return result;
    },
    getAuthList: async () => {
      const store = useUserStore();
      if (store.authList.length === 0) {
        // 如果权限列表为空，尝试重新加载用户信息以获取权限列表
        try {
          await store.fetchUserInfo();
        } catch (error) {
          console.error('重新加载用户信息失败:', error);
        }
      }

      const result = store.getAuthList();
      return result;
    }
  };
};

console.log('注册 educationCare with entry:', import.meta.env.VITE_SUBAPP_URL_educationCare);

// 注册子应用
registerMicroApps([
  // {
  //   name: 'userCenter',
  //   entry: '//localhost:8083',
  //   container: '#subapp-container',
  //   activeRule: '/sub-app/userCenter',
  //   props: {
  //     getGlobalActions: createGlobalActions
  //   }
  // },
  {
    name: 'homeCare',
    entry: import.meta.env.VITE_SUBAPP_URL_homeCare,
    container: '#subapp-container',
    activeRule: '/sub-app/homeCare',
    props: {
      getGlobalActions: createGlobalActions
    }
  },
  {
    name: 'officerCare',
    entry: import.meta.env.VITE_SUBAPP_URL_officerCare,
    container: '#subapp-container',
    activeRule: '/sub-app/officerCare',
    props: {
      getGlobalActions: createGlobalActions
    }
  },
  {
    name: 'gtzhyl',
    entry: import.meta.env.VITE_SUBAPP_URL_gtzhyl,
    container: '#subapp-container',
    activeRule: '/sub-app/gtzhyl',
    props: {
      getGlobalActions: createGlobalActions
    }
  },
  {
    name: 'educationCare',
    entry: import.meta.env.VITE_SUBAPP_URL_educationCare,
    container: '#subapp-container',
    activeRule: '/sub-app/educationCare',
    props: {
      getGlobalActions: createGlobalActions
    }
  },
  {
    name: 'elderlyHealthAsmtSys',
    entry: import.meta.env.VITE_SUBAPP_URL_elderlyHealthAsmtSys,
    container: '#subapp-container',
    activeRule: '/sub-app/elderlyHealthAsmtSys',
    props: {
      getGlobalActions: createGlobalActions
    }
  },
  {
    name: 'userManage',
    entry: import.meta.env.VITE_SUBAPP_URL_userManage,
    container: '#subapp-container',
    activeRule: '/sub-app/userManage',
    props: {
      getGlobalActions: createGlobalActions
    }
  }
]);

// 设置全局 actions，供子应用通过 window.__POWERED_BY_QIANKUN__ 访问
window.addEventListener('qiankun-global-state-change', (event: any) => {
  console.log('全局状态变化:', event.detail);
});
